import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Elena Rossi',
  role: 'Docente di Lettere, ITI',
  city: 'Milano',
  text: "Insegnare Dante in una classe terza di un tecnico era diventato un incubo. Con il Tomo 3 ho trovato la chiave per farli appassionare. Le schede visive sono perfette per mantenere l'attenzione e io non devo più passare le serate a creare slide da zero."
}, {
  name: 'Matteo Bianchi',
  role: 'Docente di Lettere, Scuola Secondaria di I grado',
  city: 'Bologna',
  text: "La sezione sull'inclusione (Bonus 1) vale da sola il prezzo del kit. Avere mappe concettuali e PDP già impostati mi ha salvato la vita con i miei studenti DSA. Finalmente un materiale che pensa alla realtà delle nostre classi."
}, {
  name: 'Silvia Romano',
  role: 'Docente di Lettere, Liceo Scientifico',
  city: 'Napoli',
  text: 'Ero scettica, ma la programmazione annuale già pronta mi ha fatto risparmiare giorni di lavoro a settembre. Le UDA sono strutturate benissimo e perfettamente allineate alle richieste del MIM. Un investimento che rifarei domani.'
}, {
  name: 'Lorenzo Ferrari',
  role: 'Docente di Lettere, Liceo Classico',
  city: 'Torino',
  text: "Il modulo sulla preparazione alla Maturità è eccezionale. Le griglie di valutazione per la Prima Prova mi hanno dimezzato i tempi di correzione dei temi. I ragazzi arrivano all'esame molto più sicuri e io sono molto più sereno."
}, {
  name: 'Chiara Esposito',
  role: 'Docente di Lettere, Istituto Professionale',
  city: 'Roma',
  text: "Ho sempre faticato a integrare l'Educazione Civica nelle mie ore di Italiano. Il Bonus 3 mi ha dato 20 unità già pronte e collegate alla Costituzione. Il metodo del Debate ha trasformato le mie lezioni: ora i ragazzi partecipano attivamente!"
}];
export function Testimonials() {
  return <section className="py-10 sm:py-14 px-4" data-id="element-235">
      <div className="max-w-6xl mx-auto" data-id="element-236">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-8 uppercase text-brand-cream" data-id="element-237">
          Cosa dicono i colleghi
        </motion.h2>

        <div className="grid grid-cols-1 gap-4" data-id="element-238">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-card border border-white/5 p-6 rounded-2xl flex flex-col" data-id="element-239">
              <div className="flex text-brand-gold mb-4" data-id="element-240">
                {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-current" data-id="element-241" />)}
              </div>
              <p className="text-gray-300 font-medium italic mb-6 flex-grow" data-id="element-242">
                "{t.text}"
              </p>
              <div className="border-t border-white/10 pt-4 mt-auto" data-id="element-243">
                <div className="font-bold text-brand-cream" data-id="element-244">{t.name}</div>
                <div className="text-sm text-brand-orange" data-id="element-245">{t.role}</div>
                <div className="text-xs text-gray-500 mt-1" data-id="element-246">{t.city}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}